var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddContractDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0.5H0V20.5H15V6.75H8.75V0.5ZM10 0.5V5.5H15L10 0.5ZM6.5625 17.6875V16.75V14.5625H4.375H3.4375V12.6875H4.375H6.5625V10.5V9.5625H8.4375V10.5V12.6875H10.625H11.5625V14.5625H10.625H8.4375V16.75V17.6875H6.5625Z",
    fill: "#98BCD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContractDialog);
export default __webpack_public_path__ + "static/media/add_contract_dialog.b908a5beef8d9815e1d6e6e3e3611efb.svg";
export { ForwardRef as ReactComponent };